import { ETenderType } from 'types/tender'

export const FROM_XLSX_TO_TENDER_TYPE: Record<string, ETenderType> = {
  'Açıq Tender (Open Tender)': ETenderType.OPEN_TENDER,
  'Qiymət Sorğusu (Price Inquiry)': ETenderType.PRICE_INQUIRY,
  'İki Mərhələli Tender (Two stage tender)': ETenderType.TWO_STAGE_TENDER,
}
